//
// This file is AUTO-GENERATED by protoc-gen-ts.
// Do not modify it manually.
///
import api from '../../api'
import * as googleTypes from '../../googleTypes'

// File: charts/v1/icharts.proto
// Package: arangodb.cloud.internal.charts.v1

// AddDeploymentChartRequest adds a chart to a deployment, whether or not it is one of the default charts.
// The version, enabled and values are the deployment overrides of the chart.
export interface AddDeploymentChartRequest {
  // The ID of the deployment.
  // string
  deployment_id?: string;
  
  // The name of the chart (must not already exist on the deployment).
  // string
  name?: string;
  
  // The version of the chart.
  // string
  version?: string;
  
  // Whether the chart is enabled.
  // boolean
  enabled?: boolean;
  
  // Optional sparse JSON object of Helm values.
  // string
  values?: string;
}

// ChartConfiguration holds the sparse chart configuration for one control plane.
export interface ChartConfiguration {
  // Control-plane stage (development, staging, production).
  // string
  environment?: string;
  
  // Sparse per-chart configuration.
  // ChartConfigurationEntry
  charts?: ChartConfigurationEntry[];
  
  // Canonical YAML representation of the sparse configuration.
  // string
  yaml?: string;
  
  // Timestamp when the configuration was last updated.
  // googleTypes.Timestamp
  updated_at?: googleTypes.Timestamp;
  
  // Optional sparse JSON object of Helm values that apply to all charts.
  // Merged over the template's default_overrides, and included in ExportChartsYAML.
  // string
  default_values?: string;
  
  // Optional sparse JSON object of Helm values that apply to all charts in this environment only.
  // Merged over default_values, and never included in ExportChartsYAML.
  // string
  environment_values?: string;
  
  // Read-only: dotted Helm value paths in default_values whose value equals the template's default_overrides.
  // string
  redundant_default_value_paths?: string[];
}

// ChartConfigurationEntry holds sparse configuration for a single chart.
export interface ChartConfigurationEntry {
  // The name of the chart.
  // string
  name?: string;
  
  // Optional configured chart version (empty when not configured).
  // string
  version?: string;
  
  // True when the enabled/autostart flag is configured here.
  // boolean
  has_enabled?: boolean;
  
  // Configured enabled/autostart value when has_enabled is true.
  // boolean
  enabled?: boolean;
  
  // Optional sparse JSON object of configured Helm values.
  // string
  values?: string;
  
  // Read-only: true when this chart does not exist in the template and is not an addition.
  // boolean
  orphaned?: boolean;
  
  // Read-only: true when version is set and equals the template version.
  // boolean
  version_redundant?: boolean;
  
  // Read-only: true when has_enabled is true and enabled equals the template enabled state.
  // boolean
  enabled_redundant?: boolean;
  
  // Read-only: dotted Helm value paths whose configured value equals the template value.
  // string
  redundant_value_paths?: string[];
  
  // True when this entry adds a chart that is not in the template.
  // An addition requires a version and is never orphaned.
  // boolean
  addition?: boolean;
}

// ChartDiagnostic is a problem found in chart configuration or deployment overrides.
export interface ChartDiagnostic {
  // ChartDiagnosticSeverity
  severity?: ChartDiagnosticSeverity;
  
  // The chart the problem is about. Empty when it is about the configuration as a whole.
  // string
  chart?: string;
  
  // The location of the problem: a configuration key (for example packages.mlflow.overrides)
  // or a dotted Helm value path. Dots and backslashes in a key are escaped with a backslash.
  // string
  path?: string;
  
  // Human readable description of the problem.
  // string
  message?: string;
}

// ClearChartConfigurationRequest clears all or selected chart configuration.
export interface ClearChartConfigurationRequest {
  // Optional chart names to clear. When empty and both flags below are false, clears all configuration,
  // including default_values and environment_values.
  // string
  chart_names?: string[];
  
  // When true, removes only orphaned chart entries not present in the template.
  // boolean
  orphaned_only?: boolean;
  
  // When true, removes only configured fields whose values equal the current template.
  // This includes redundant paths in default_values.
  // boolean
  redundant_only?: boolean;
}

// DefaultChart describes a resolved effective default chart with per-field provenance.
export interface DefaultChart {
  // The name of the chart.
  // string
  name?: string;
  
  // Effective default version.
  // string
  version?: string;
  
  // Effective default enabled/autostart state.
  // boolean
  enabled?: boolean;
  
  // Effective default Helm values (JSON).
  // string
  values?: string;
  
  // Source of version.
  // ChartValueSource
  version_source?: ChartValueSource;
  
  // Source of enabled.
  // ChartValueSource
  enabled_source?: ChartValueSource;
  
  // Source of each dotted Helm value path.
  // map<string, arangodb.cloud.internal.charts.v1.ChartValueSource>
  value_sources?: { [key: string]: ChartValueSource };
  
  // Underlying template version.
  // string
  template_version?: string;
  
  // Underlying template enabled/autostart state.
  // boolean
  template_enabled?: boolean;
  
  // Underlying template Helm values (JSON).
  // string
  template_values?: string;
  
  // True when chart configuration sets version to the same value as the template.
  // boolean
  version_redundant?: boolean;
  
  // True when chart configuration sets enabled to the same value as the template.
  // boolean
  enabled_redundant?: boolean;
  
  // Dotted Helm value paths where chart configuration equals the template value.
  // string
  redundant_value_paths?: string[];
  
  // Helm values (JSON) that the chart configuration contributes to this chart: default_values,
  // environment_values and the values of the chart entry, merged.
  // string
  configuration_values?: string;
}

// DefaultChartList contains the resolved effective defaults for the active environment.
export interface DefaultChartList {
  // Active environment name.
  // string
  environment?: string;
  
  // Resolved effective default charts.
  // DefaultChart
  items?: DefaultChart[];
  
  // Leftover configuration entries for charts not present in the template.
  // ChartConfigurationEntry
  orphaned_entries?: ChartConfigurationEntry[];
}

// DeploymentChart is the compiled chart of a deployment: the default chart with the deployment overrides applied.
// This is what the data cluster deploys. Use DeploymentChartLayers to see how it was resolved.
export interface DeploymentChart {
  // The ID of the deployment chart.
  // This is a read-only value.
  // string
  id?: string;
  
  // The ID of the deployment.
  // string
  deployment_id?: string;
  
  // The name of the chart.
  // string
  name?: string;
  
  // The compiled version of the chart.
  // string
  version?: string;
  
  // The compiled Helm values (JSON).
  // string
  values?: string;
  
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // The platform bundle this chart was stamped from.
  // Empty when the chart was added manually, or when the bundle is unknown.
  // An empty bundle never triggers a reset of the deployment charts.
  // string
  bundle?: string;
  
  // Whether the chart is enabled.
  // boolean
  enabled?: boolean;
  
  // True when the chart has deployment overrides (read-only, derived from the overrides).
  // Overrides only pin the fields they name, the other fields follow the default chart.
  // boolean
  override?: boolean;
  
  // DeploymentChartStatus
  status?: DeploymentChartStatus;
  
  // Deprecated: use DeploymentChartLayers.in_defaults.
  // Field number 20 is reserved once consumers have moved.
  // boolean
  in_defaults?: boolean;
  
  // Deprecated: use DeploymentChartLayers.out_of_date.
  // boolean
  out_of_date?: boolean;
  
  // Deprecated: use DeploymentChartLayers.version_source.
  // ChartValueSource
  version_source?: ChartValueSource;
  
  // Deprecated: use DeploymentChartLayers.enabled_source.
  // ChartValueSource
  enabled_source?: ChartValueSource;
  
  // Deprecated: use DeploymentChartLayers.value_sources.
  // map<string, arangodb.cloud.internal.charts.v1.ChartValueSource>
  value_sources?: { [key: string]: ChartValueSource };
  
  // Deprecated: use DeploymentChartLayers.default_chart.
  // DefaultChart
  effective_default?: DefaultChart;
}

// DeploymentChartLayers shows how the compiled chart of a deployment is resolved from its layers.
export interface DeploymentChartLayers {
  // The ID of the deployment.
  // string
  deployment_id?: string;
  
  // The name of the chart.
  // string
  name?: string;
  
  // The compiled chart, as it is deployed to the data cluster.
  // DeploymentChart
  chart?: DeploymentChart;
  
  // The default chart: template merged with the chart configuration.
  // Not set when the chart is not one of the default charts.
  // Its template_values and configuration_values are the template and configuration layers.
  // DefaultChart
  default_chart?: DefaultChart;
  
  // The deployment overrides.
  // DeploymentChartOverrides
  overrides?: DeploymentChartOverrides;
  
  // True when this chart exists in the current default charts.
  // boolean
  in_defaults?: boolean;
  
  // True when the compiled chart differs from what the default chart and the overrides resolve to now,
  // for example because the template changed and the deployment charts are not synchronized yet.
  // boolean
  out_of_date?: boolean;
  
  // Source of the compiled version.
  // ChartValueSource
  version_source?: ChartValueSource;
  
  // Source of the compiled enabled state.
  // ChartValueSource
  enabled_source?: ChartValueSource;
  
  // Source of each dotted Helm value path of the compiled chart.
  // map<string, arangodb.cloud.internal.charts.v1.ChartValueSource>
  value_sources?: { [key: string]: ChartValueSource };
}

// DeploymentChartLayersList contains the layered charts of a deployment.
export interface DeploymentChartLayersList {
  // The ID of the deployment.
  // string
  deployment_id?: string;
  
  // The layered charts.
  // DeploymentChartLayers
  items?: DeploymentChartLayers[];
}

// DeploymentChartList contains the compiled deployment charts for a deployment.
export interface DeploymentChartList {
  // The ID of the deployment.
  // string
  deployment_id?: string;
  
  // Compiled deployment charts.
  // DeploymentChart
  items?: DeploymentChart[];
}

// DeploymentChartOverrides are the sparse deployment overrides of a chart.
// They are applied over the default chart, a field that is not set keeps following the default chart.
// For a chart that is not one of the default charts, the overrides are the whole chart.
export interface DeploymentChartOverrides {
  // Optional version override (empty when the version follows the default chart).
  // string
  version?: string;
  
  // True when enabled is overridden.
  // boolean
  has_enabled?: boolean;
  
  // Overridden enabled state when has_enabled is true.
  // boolean
  enabled?: boolean;
  
  // Optional sparse JSON object of Helm values, merged over the Helm values of the default chart.
  // string
  values?: string;
}

// DeploymentChartStatus is the Helm release status of a deployment chart.
export interface DeploymentChartStatus {
  // googleTypes.Timestamp
  FirstDeployed?: googleTypes.Timestamp;
  
  // googleTypes.Timestamp
  LastDeployed?: googleTypes.Timestamp;
  
  // googleTypes.Timestamp
  Deleted?: googleTypes.Timestamp;
  
  // string
  Status?: string;
  
  // string
  Description?: string;
  
  // number
  ReleaseVersion?: number;
  
  // string
  ChartVersion?: string;
}

// ExportChartsYAMLRequest selects what to export as a new charts.yaml.
export interface ExportChartsYAMLRequest {
  // Optional chart names to export from the chart configuration. Charts that are not listed keep their template
  // values. When empty, all chart configuration is exported.
  // string
  chart_names?: string[];
}

// ExportChartsYAMLResponse contains the exported charts.yaml.
export interface ExportChartsYAMLResponse {
  // The template with the selected chart configuration and default_values applied.
  // environment_values are not included.
  // string
  yaml?: string;
}

// ExportDeploymentChartsRequest selects the compiled charts of a deployment to export.
export interface ExportDeploymentChartsRequest {
  // The ID of the deployment.
  // string
  deployment_id?: string;
  
  // Optional chart names to export. When empty, all charts of the deployment are exported.
  // string
  chart_names?: string[];
}

// ExportDeploymentChartsResponse contains the exported compiled charts.
export interface ExportDeploymentChartsResponse {
  // The compiled charts as deployed to the data cluster, a YAML document with a charts list.
  // Every item has name, version, enabled and values.
  // string
  yaml?: string;
}

// ListDeploymentChartsRequest requests the charts of a deployment.
export interface ListDeploymentChartsRequest {
  // The ID of the deployment.
  // string
  deployment_id?: string;
  
  // Optional filter: chart name.
  // string
  name?: string;
}

// PreviewDeploymentChartRequest resolves deployment overrides without storing them.
export interface PreviewDeploymentChartRequest {
  // The ID of the deployment.
  // string
  deployment_id?: string;
  
  // The name of the chart. The chart does not have to exist on the deployment yet,
  // a chart that is not in the default charts needs a version in the overrides.
  // string
  name?: string;
  
  // The deployment overrides to resolve.
  // DeploymentChartOverrides
  overrides?: DeploymentChartOverrides;
}

// PreviewDeploymentChartResponse contains the result of resolving deployment overrides.
export interface PreviewDeploymentChartResponse {
  // The chart as it would be resolved. Not set when there are diagnostics with severity error.
  // DeploymentChartLayers
  layers?: DeploymentChartLayers;
  
  // The compiled chart as YAML, in the format of ExportDeploymentChartsResponse.yaml.
  // Not set when there are diagnostics with severity error.
  // string
  yaml?: string;
  
  // Problems found in the overrides.
  // ChartDiagnostic
  diagnostics?: ChartDiagnostic[];
}

// RemoveDeploymentChartRequest removes a chart from a deployment.
export interface RemoveDeploymentChartRequest {
  // The ID of the deployment.
  // string
  deployment_id?: string;
  
  // The name of the chart to remove.
  // string
  name?: string;
}

// ResetDeploymentChartRequest resets a deployment chart to the current default chart and clears its overrides.
export interface ResetDeploymentChartRequest {
  // The ID of the deployment.
  // string
  deployment_id?: string;
  
  // The name of the chart to reset.
  // string
  name?: string;
}

// SetDeploymentChartOverridesRequest replaces the deployment overrides of a chart.
export interface SetDeploymentChartOverridesRequest {
  // The ID of the deployment.
  // string
  deployment_id?: string;
  
  // The name of the chart.
  // string
  name?: string;
  
  // The new deployment overrides. Empty overrides clear all overrides.
  // DeploymentChartOverrides
  overrides?: DeploymentChartOverrides;
}

// SyncDeploymentChartsRequest resolves all charts on a deployment again from the default charts and the deployment overrides.
export interface SyncDeploymentChartsRequest {
  // The ID of the deployment.
  // string
  deployment_id?: string;
}

// UpdateChartConfigurationRequest replaces the active control plane's sparse chart configuration.
export interface UpdateChartConfigurationRequest {
  // Structured sparse per-chart configuration (used when yaml is empty).
  // ChartConfigurationEntry
  charts?: ChartConfigurationEntry[];
  
  // Optional YAML representation of the sparse configuration (takes precedence when non-empty).
  // string
  yaml?: string;
  
  // Optional sparse JSON object of Helm values that apply to all charts (used when yaml is empty).
  // string
  default_values?: string;
  
  // Optional sparse JSON object of Helm values that apply to all charts in this environment only
  // (used when yaml is empty).
  // string
  environment_values?: string;
}

// ValidateChartConfigurationResponse contains the result of validating a chart configuration.
export interface ValidateChartConfigurationResponse {
  // The configuration as it would be stored, in canonical form.
  // Not set when there are diagnostics with severity error.
  // ChartConfiguration
  configuration?: ChartConfiguration;
  
  // Problems found in the configuration, including keys that are not part of the configuration.
  // ChartDiagnostic
  diagnostics?: ChartDiagnostic[];
}

// ChartDiagnosticSeverity is the severity of a ChartDiagnostic.
export enum ChartDiagnosticSeverity {
  CHART_DIAGNOSTIC_SEVERITY_UNSPECIFIED = 0,
  
  // The input cannot be stored.
  CHART_DIAGNOSTIC_SEVERITY_ERROR = 1,
  
  // The input can be stored, but is probably not what was intended.
  CHART_DIAGNOSTIC_SEVERITY_WARNING = 2,
}

// ChartValueSource identifies which layer supplied a resolved chart field.
export enum ChartValueSource {
  CHART_VALUE_SOURCE_UNSPECIFIED = 0,
  
  // The field comes from the chart template in config.
  CHART_VALUE_SOURCE_TEMPLATE = 1,
  
  // The field comes from the sparse chart configuration in chartd's database.
  CHART_VALUE_SOURCE_CONFIGURATION = 2,
  
  // The field comes from the deployment chart.
  CHART_VALUE_SOURCE_DEPLOYMENT = 3,
}

// InternalChartAuthoringService is the API used to program charts: the chart configuration of an environment and
// the overrides of a deployment chart. It is used by idashboard and zutano. location: CP
// A chart is resolved from three layers, the last one wins:
// the template (charts.yaml in config), the chart configuration of the environment, and the deployment overrides.
export interface IInternalChartAuthoringService {
}

// InternalChartAuthoringService is the API used to program charts: the chart configuration of an environment and
// the overrides of a deployment chart. It is used by idashboard and zutano. location: CP
// A chart is resolved from three layers, the last one wins:
// the template (charts.yaml in config), the chart configuration of the environment, and the deployment overrides.
export class InternalChartAuthoringService implements IInternalChartAuthoringService {
}

// InternalChartService is the API used to consume the compiled charts of a deployment. location: CP
// The data cluster side (dataclusterd, data-manager) only uses this service.
// Charts are programmed through InternalChartAuthoringService.
export interface IInternalChartService {
}

// InternalChartService is the API used to consume the compiled charts of a deployment. location: CP
// The data cluster side (dataclusterd, data-manager) only uses this service.
// Charts are programmed through InternalChartAuthoringService.
export class InternalChartService implements IInternalChartService {
}
